import React, { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import Header from "../components/header/Header";
import { SHOW_PIECES } from "../constants/piecesIcon";
import DesktopView from "../components/desktopview/DesktopView";
import axios from "axios";
import ServiceHistoryBox from "../components/serviceHistoryBox/ServiceHistoryBox";
import ServicePlaceCancel from "../components/modals/ServicePlaceCancel";
import BlueLoader from "../components/loader/BlueLoader";
import { TbMoodSad } from "react-icons/tb";
import MessageModals from "../components/modals/MessageModals";
import globalContext from "../Contexts/GlobalContext";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import useRequestHeader from "../hooks/useRequestHeader";

export default function CurrentServicePlace() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const [historyItems, setHistoryItems] = useState([]);
  const [isHistoryItemsLoading, setIsHistoryItemsLoading] = useState(false);

  const [isCancelServicePlaceOpen, setIsCancelServicePlaceOpen] =
    useState(false);
  const [cancelRefId, setCancelRefId] = useState("");
  const [cancelType, setCancelType] = useState("");
  const [isCancelLoading, setIsCancelLoading] = useState(false);

  const [updatehistoryListFlag, setUpdatehistoryListFlag] = useState(false);
  const [isAllLoading, setIsAllLoading] = useState(false);

  useEffect(() => {
    if (!isAllLoading) {
      setIsHistoryItemsLoading(true);
      setIsAllLoading(true);
    }
    const config = {
      headers: requestHeader,
    };
    axios
      .post(
        `${BASE_URL}/service/place/detailHistory`,
        {
          plate: cookies?.plate,
        },
        config
      )
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            setHistoryItems(res?.data?.Data);
            setIsHistoryItemsLoading(false);
            break;
          }
          case SERVERMODE.SERVICE_NOT_EXIST: {
            setHistoryItems(null);
            setIsHistoryItemsLoading(false);
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
          }
        }
      })
      .catch((err) => {
        setIsHistoryItemsLoading(false);
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
      });
  }, [updatehistoryListFlag]);

  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="absolute w-full top-0 bottom-0 flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden "
        onClick={() => {
          //   if (isSupportRequest === "true") {
          //     setIsSupportRequest("false");
          //   }
        }}
      >
        <Header relt="relative" />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
            bottom={10}
          />
        )}
        {isCancelServicePlaceOpen && (
          <ServicePlaceCancel
            setIsCancelServicePlaceOpen={setIsCancelServicePlaceOpen}
            cancelRefId={cancelRefId}
            cancelType={cancelType}
            setIsCancelLoading={setIsCancelLoading}
            setUpdatehistoryListFlag={setUpdatehistoryListFlag}
          />
        )}

        <div
          className={`w-[100vw] h-full flex flex-col items-center justify-start  gap-y-[2vw] pb-[4vw] `}
        >
          <div className="w-full flex flex-col items-center justify-center p-[2vw] my-[12vw]">
            <p className="font-font_primary_A text-[5.5vw] text-white font-bold">
              تاریخچه سرویس در محل
            </p>
            <div className="w-full flex items-center justify-center  font-font_primary_A  text-white   rounded-[0.9vw]  text-[3vw]  mt-[2vw]">
              <span className=" rounded-[0.9vw] py-[0.5vw] px-[2vw] ">
                فهرست تاریخچه سرویس های قبلی و جاری شما
              </span>
            </div>
          </div>
          <div className="w-full  h-auto flex flex-col items-center justify-start overflow-scroll gap-y-[4vw] pb-[15vw]  ">
            {historyItems?.map((history) => {
              return (
                <ServiceHistoryBox
                  key={history?.reference}
                  type={history?.type}
                  status={history?.referenceMode}
                  servicerMan={history?.fullName}
                  date={history?.referenceDate}
                  time={history?.referenceTime}
                  address={history?.address}
                  referenceId={history?.reference}
                  setIsCancelServicePlaceOpen={setIsCancelServicePlaceOpen}
                  setCancelType={setCancelType}
                  cancelRefId={cancelRefId}
                  setCancelRefId={setCancelRefId}
                  isCancelLoading={isCancelLoading}
                />
              );
            })}
            {!historyItems && !isHistoryItemsLoading && (
              <div className="absolute w-full h-full   top-0  rounded-[2vw] flex flex-col items-center justify-center font-font_primary_A text-color-primary-C3 tetx-[4vw]">
                <span className="text-[10vw]">
                  <TbMoodSad />
                </span>
                <span>سرویسی برای نمایش وجود ندارد</span>
              </div>
            )}
            {isHistoryItemsLoading && (
              <div className="absolute w-full h-full   top-0  rounded-[2vw] flex items-center justify-center">
                <BlueLoader position="" width={15} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
